/**
 * [小运力钱包列表]
 * @author: Sun yue
 * @date: 2022-07-28 
 */

import http from '@/assets/api/http';

// 小运力钱包列表
export async function getTransportCompanyWalletList(params) {
  return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportWalletMisService.listTransportWallet', params, 'POST',15000);
}

// 小运力钱包详情
export async function getTransportCompanyWalletDetail(params) {
  return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportWalletMisService.transportWalletDetail', params, 'POST');
}

// 账户明细
export async function getTransportTransDetail(params) {
  return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportWalletMisService.transportTransDetail', params, 'POST');
}

// 提现记录
export async function getListTransportWithdraw(params) {
  return http('/?cmd=com.xqxc.api.pig.mis.pay.TransportWalletMisService.listTransportWithdraw', params, 'POST');
}

